// angular
import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Params } from '@angular/router';

// interfaces
import { IProduct } from '@app/+products/shared/interfaces/product.interface';
import { ITender } from '@app/+tenders/shared/interfaces/tender.interface';
import { IAuction } from '@app/+auctions/shared/types/auctions.type';
import { IElasticSearchData } from '../interfaces/elastic-search-data.interface';
import { IBusiness } from '@app/+suppliers/shared/interfaces/business.interface';

@Injectable()
export class ElasticSearchService {
  public allData = signal<IElasticSearchData | null>(null);
  public auctionsCount = signal<number>(0);
  public auctionsData = signal<IAuction[] | null>(null);
  public businessesCount = signal<number>(0);
  public businessesData = signal<IBusiness[] | null>(null);
  public installersCount = signal<number>(0);
  public installersData = signal<IBusiness[] | null>(null);
  public architectsCount = signal<number>(0);
  public architectsData = signal<IBusiness[] | null>(null);
  public developersCount = signal<number>(0);
  public developersData = signal<IBusiness[] | null>(null);
  public productsCount = signal<number>(0);
  public productsData = signal<IProduct[] | null>(null);
  public tendersCount = signal<number>(0);
  public tendersData = signal<ITender[] | null>(null);
  public loadingState = signal<boolean>(false);

  private readonly _httpClient = inject(HttpClient);

  constructor() {}

  public searchItem(params: Params) {
    // set loading state
    this.loadingState.set(true);

    return this._httpClient
      .get<IElasticSearchData>('main/search', {
        params: { ...params, limit: 4 },
        headers: { 'x-custom-lang': '' },
      })
      .subscribe({
        next: res => {
          this.auctionsCount.set(res.auctions.count);
          this.auctionsData.set(res.auctions.data);
          this.businessesCount.set(res.businesses.count);
          this.businessesData.set(res.businesses.data);
          this.installersCount.set(res.installers?.count ?? 0);
          this.installersData.set(res.installers?.data ?? []);
          this.architectsCount.set(res.architects?.count ?? 0);
          this.architectsData.set(res.architects?.data ?? []);
          this.developersCount.set(res.developers?.count ?? 0);
          this.developersData.set(res.developers?.data ?? []);
          this.productsCount.set(res.products.count);
          this.productsData.set(res.products.data);
          this.tendersCount.set(res.tenders.count);
          this.tendersData.set(res.tenders.data);
          this.allData.set(res);
        },
        error: err => {
          console.error('Error fetching search results', err);
          // set loading state
          this.loadingState.set(false);
        },
        complete: () => {
          // set loading state
          this.loadingState.set(false);
        },
      });
  }
}
